<script>
	import { request } from "../../scripts/request";
	import { changeHash, removeHashByType } from "../../scripts/change_hash";

	import {
		isMenuClosed,
		userEntity,
		clinicsNum,
		menuEntity,
		currentEntityID,
	} from "../../stores/variables";
	import {
		clinicsData,
		currentActiveObjectData,
		menuData,
		entityData,
		blankClinicData,
		profileData,
	} from "../../stores/data";

	import Menu from "./menu/Menu.svelte";
	import Body from "./body/Body.svelte";

	function getMenu(url) {
		url = "menus/" + url + "_menu";
		let response = request.fetchLocalData(url);
		response.then((result) => {
			$menuData = result;
		});
	}
	getMenu($userEntity);

	if ($userEntity) {
		if (
			$userEntity == "clinic_moderator" ||
			$userEntity == "clinic_owner"
		) {
			$menuEntity = "clinic";
			removeHashByType("doctor");
		}
		if ($userEntity == "doctor") {
			$menuEntity = "doctor";
			removeHashByType("clinic");
		}
	}

	if ($menuEntity == "clinic") {
		let searchParams = new URLSearchParams(window.location.search);
		let clinic_id = searchParams.get("clinic_id") || "";
		if (clinic_id) {
			searchParams.delete("clinic_id");
			const nextURL =
				window.location.origin +
				window.location.pathname +
				searchParams.toString() +
				window.location.hash;
			history.replaceState(null, "", nextURL);
		}
		request
			.fetchData("BlankClinic", "BlankClinic", {}, { method: "GET" })
			.then((result) => {
				$blankClinicData = result.data;
				$blankClinicData.ID = 0;
				request
					.fetchData("clinicsList", "clinicsList")
					.then((result) => {
						$clinicsData = Object.values(result.data.clinics);
						if (clinic_id) {
							$clinicsData.forEach((clinic) => {
								if (clinic.ID == clinic_id) {
									$currentActiveObjectData = $entityData =
										clinic;
									changeHash("clinic", clinic_id);
								}
							});
						} else {
							if ($clinicsData[0]) {
								$currentActiveObjectData = $entityData =
									$clinicsData[0];
							} else {
								$currentActiveObjectData = $entityData =
									$blankClinicData;
							}
						}
						$clinicsNum = result.data.num_all;
						let hashes = window.location.hash;
						if (hashes) {
							hashes = hashes.split("/");
							if (hashes) {
								let isExist = false;
								hashes.forEach((_hash) => {
									let temp = _hash.split("=");
									if (temp[0][0] == "#")
										temp[0] = temp[0].slice(1);
									if (temp[0] == $menuEntity) {
										isExist = true;
										// if (temp[1] == 0) {
										// 	$currentActiveObjectData =
										// 		$blankClinicData;
										// }
									}
								});
								if (!isExist) {
									changeHash(
										$menuEntity,
										$currentActiveObjectData.ID
									);
								}
							}
						} else {
							changeHash(
								$menuEntity,
								$currentActiveObjectData.ID
							);
						}
					});
			});
	}
	if ($menuEntity == "doctor" && $profileData) {
		request
			.fetchData("DoctorUser", "DoctorUser", {
				userID: +$profileData["ID"],
			})
			.then((result) => {
				$currentActiveObjectData = result.data;
				$currentEntityID = result.data["ID"];
			});
	}
</script>

<div class="wrapper {$isMenuClosed ? 'menu-closed' : 'menu-opened'}">
	{#if $currentActiveObjectData}
		{#if $menuData}
			<Menu data={$menuData} />
		{/if}
		<Body />
	{/if}
</div>

<style lang="scss">
	.wrapper {
		height: 100vh;
		display: flex;
		background: var(--bg-main-1);

		@media (max-width: 991px) {
			flex-direction: column;
			&.menu-opened {
				overflow: hidden;
			}
		}
	}
</style>
